"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CardFooter: function() {
        return _index.CardFooter;
    },
    cardFooterClassNames: function() {
        return _index.cardFooterClassNames;
    },
    renderCardFooter_unstable: function() {
        return _index.renderCardFooter_unstable;
    },
    useCardFooterStyles_unstable: function() {
        return _index.useCardFooterStyles_unstable;
    },
    useCardFooter_unstable: function() {
        return _index.useCardFooter_unstable;
    }
});
const _index = require("./components/CardFooter/index");
